<script setup lang="ts">
import type { JSX } from '@ionic/core'

const props = withDefaults(defineProps<JSX.IonItem & { readonly?: boolean, error?: boolean }>(),
	{
		lines: 'full',
	})
</script>

<template>
	<ion-item
		:class="{ readonly, error }"
		v-bind.attr="$attrs"
		v-bind.prop="props"
	>
		<slot />
	</ion-item>
</template>

<style lang="scss" scoped>
ion-item {
	--min-height: 45px;
	--border-color: var(--ion-color-grey-5);
	&.error {
		--background: var(--ion-color-danger);
		--color: var(--ion-color-danger-contrast);
		--border-color: var(--ion-color-primary-contrast);
		--border-width: 2px 0px 2px 0px;
		&:deep(.label-text-wrapper) {
			font-weight: 600;
		}
	}
}
</style>
